import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { values } from 'ramda';

import { Container } from './page.styles';
import { Theme } from '../../../modules/headerBar/themes';

export class Page extends PureComponent {
  static propTypes = {
    setHeaderTheme: PropTypes.func.isRequired,
    children: PropTypes.any,
    headerTheme: PropTypes.oneOf(values(Theme)),
    className: PropTypes.string,
  };

  static defaultProps = {
    headerTheme: Theme.FILLED,
  };

  componentDidMount() {
    this.props.setHeaderTheme(this.props.headerTheme);
  }

  render() {
    const { children, headerTheme, className } = this.props;

    return (
      <Container className={className} withPadding={headerTheme === Theme.FILLED}>
        {children}
      </Container>
    );
  }
}
